// ScopeChoiceDialog.js - val "Bara detta tillfälle" / "Detta och alla kommande"
// när deltagare läggs till eller tas bort i en återkommande gruppserie (Spår G).

import React, { useCallback, useRef, useState } from 'react';
import './Calendar.css';

const ScopeChoiceDialog = ({ question, detail, onChoose }) => (
  <div className="modal-overlay scope-choice-overlay" onClick={() => onChoose(null)}>
    <div
      className="modal-content scope-choice-dialog"
      style={{ maxWidth: '420px' }}
      onClick={e => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-header">
        <h3><i className="fas fa-redo"></i> {question}</h3>
        <button className="close-btn" onClick={() => onChoose(null)}>&times;</button>
      </div>
      <div className="modal-body">
        {detail && <p style={{ marginTop: 0 }}>{detail}</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <button type="button" className="btn btn-primary" onClick={() => onChoose('this')}>
            Bara detta tillfälle
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => onChoose('following')}>
            Detta och alla kommande
          </button>
        </div>
      </div>
      <div className="modal-footer">
        <div className="right-buttons">
          <button type="button" className="btn btn-secondary" onClick={() => onChoose(null)}>
            Avbryt
          </button>
        </div>
      </div>
    </div>
  </div>
);

// Hook: const [scopeDialog, askScope] = useScopeChoice();
// const scope = await askScope('Lägg till deltagare'); // 'this' | 'following' | null
export const useScopeChoice = () => {
  const [prompt, setPrompt] = useState(null);
  const resolveRef = useRef(null);

  const askScope = useCallback((question, detail = null) => new Promise(resolve => {
    resolveRef.current = resolve;
    setPrompt({ question, detail });
  }), []);

  const choose = (scope) => {
    setPrompt(null);
    if (resolveRef.current) resolveRef.current(scope);
    resolveRef.current = null;
  };

  const dialog = prompt
    ? <ScopeChoiceDialog question={prompt.question} detail={prompt.detail} onChoose={choose} />
    : null;
  return [dialog, askScope];
};

export default ScopeChoiceDialog;
